module.exports = __webpack_public_path__ + "assets/1624af4fdec969de7bfd21abf1f20ee0.wav";